
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 6.5h-3v-1a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v1H5a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3Zm-9-1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1h-4v-1Zm10 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V13a21.27 21.27 0 0 0 3 .94v.59a1 1 0 1 0 2 0v-.21a23 23 0 0 0 3 .21 22.998 22.998 0 0 0 3-.21v.21a1 1 0 0 0 2 0v-.59a21.27 21.27 0 0 0 3-.94v5.5Zm0-7.69c-.973.41-1.976.745-3 1v-.31a1 1 0 0 0-2 0v.74c-1.989.3-4.011.3-6 0v-.74a1 1 0 1 0-2 0v.33a20.393 20.393 0 0 1-3-1V9.5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1.31Z","fill":"currentColor"}})])
          )
        }
      }
    